import type { CityConfig } from "../city-template/types";

export const charlotteConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Charlotte",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "charlotte",
  route: "/cities/charlotte",
  title: "Emergency Passport Charlotte, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Charlotte, NC — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Charlotte banking professionals, CLT passengers, NASCAR travelers, and Carolina families.",
  h1: "Emergency & Expedited Passport Services in Charlotte, NC",
  heroSubtitle: "CLT flight to London in two weeks? Banking conference in Frankfurt? NASCAR race in Monaco? We help Charlotte residents — from Uptown executives to Ballantyne families to Lake Norman professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20photograph%20of%20Charlotte%20North%20Carolina%20skyline%20at%20golden%20hour%20with%20modern%20glass%20skyscrapers%20reflecting%20warm%20amber%20sunlight%2C%20the%20Bank%20of%20America%20Corporate%20Center%20tower%20visible%2C%20lush%20green%20tree%20canopy%20in%20the%20foreground%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20sharp%20architectural%20details%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=charlotte-hero-nc-001&orientation=landscape",
  heroImageAlt: "Charlotte North Carolina downtown skyline at golden hour with modern skyscrapers",
  geoPosition: "35.2271;-80.8431",
  geoPlacename: "Charlotte, North Carolina",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 250 miles from Charlotte via I-85. North Carolina has no passport agency of its own.",
  },
  nearbyCitiesZips: [
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Matthews", zips: "28104, 28105" },
    { name: "Mint Hill", zips: "28227, 28262" },
    { name: "Huntersville", zips: "28070, 28078" },
    { name: "Concord", zips: "28025–28027" },
    { name: "Gastonia", zips: "28052–28056" },
    { name: "Mooresville", zips: "28115, 28117" },
    { name: "Cornelius", zips: "28031" },
    { name: "Davidson", zips: "28035, 28036" },
    { name: "Pineville", zips: "28134" },
    { name: "Fort Mill, SC", zips: "29707, 29708, 29715, 29716" },
    { name: "Rock Hill, SC", zips: "29730–29733" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour CLT Emergency Processing", desc: "Reserved courier access bypasses the 250-mile drive to Atlanta — as fast as 24 hours for Charlotte travelers with immediate departures." },
    { icon: "ri-flight-takeoff-line", title: "CLT Airport Expertise", desc: "American Airlines' second-largest hub with 180+ nonstop destinations including London, Frankfurt, Munich, Madrid, and Dublin. We know AA hub dynamics." },
    { icon: "ri-bank-line", title: "Banking & Finance Hub", desc: "Bank of America HQ, Wells Fargo Eastern HQ, Truist HQ — the second-largest banking center in the U.S. Short-notice international finance travel is the norm." },
    { icon: "ri-trophy-line", title: "NASCAR & Motorsports", desc: "NASCAR Hall of Fame, Charlotte Motor Speedway, 90% of NASCAR teams based within 50 miles. Global racing calendar creates year-round international travel." },
  ],
  internalLinks: [
    { name: "Fast passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Expedited passport in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Quick passport services in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "North Carolina passport services overview", route: "/northcarolina" },
  ],
  fpcOfficeAddress: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
  fpcOfficeNote: "Fast Passport Center serves Charlotte via secure registered courier with direct access to the Atlanta Passport Agency 250 miles away. Our registered couriers hand-deliver your documents — meaning you get faster results without the 4-hour drive down I-85. Charlotte residents can ship from any UPS Store, FedEx Office, or post office location across Mecklenburg County.",
  fpcOfficeDistance: "Serving Charlotte, Matthews, Huntersville, Concord, Gastonia, Mooresville, Cornelius, Davidson, Fort Mill (SC), Rock Hill (SC), and all Charlotte metro communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Charlotte and the greater Charlotte-Concord-Gastonia metropolitan area. From Uptown Charlotte's banking towers to the suburban communities of Ballantyne, SouthPark, and Lake Norman, from the NASCAR race shops of Mooresville to the South Carolina border communities of Fort Mill and Rock Hill — we serve all of Mecklenburg County, Cabarrus County, Gaston County, Iredell County, and York County (SC). Our courier service eliminates the 250-mile drive to Atlanta.",
  nearbyCitiesIntro: "We serve Charlotte and all Charlotte metro communities including Matthews, Mint Hill, Huntersville, Concord, Gastonia, Mooresville, Cornelius, Davidson, Pineville, and across the state line into Fort Mill and Rock Hill, South Carolina. We also serve travelers departing from CLT Douglas International Airport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Charlotte as simple as possible — with the efficiency and reliability banking professionals, NASCAR teams, and Carolina families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Charlotte travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Charlotte travelers encounter unique passport issues — everything from CLT same-day AA bookings to banking conference timing to the 250-mile Atlanta agency drive. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Charlotte travelers — from Uptown bankers to Lake Norman families to NASCAR professionals — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Charlotte, NC? Here are the most common ones we hear from Queen City travelers.",
  statePageRoute: "/northcarolina",
  statePageName: "North Carolina",
  servicesIntro: "Whether you need a renewal before a CLT flight to London, an emergency passport for a banking conference in Zurich, or a first-time passport for a Carolina family's first international vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround — no Atlanta drive", "Ideal for banking conferences and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 250 miles to Atlanta — 4+ hours each way", "Full day or overnight commitment — not practical for most Charlotte residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "CLT flight to London in two days? Banking deal closing in Frankfurt? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Charlotte-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Charlotte residents renew fast — no agency visit required for most renewals. Perfect for Uptown bankers, Lake Norman professionals, and Carolina families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Charlotte residents through every step — from Uptown to Ballantyne to Huntersville — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your CLT international connection or banking trip isn't derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Carolina family vacation abroad stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Charlotte professionals after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Charlotte banking executives, NASCAR team members, and global finance professionals who travel while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Charlotte-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Perfect for Charlotte cruise passengers and Caribbean resort travelers.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Charlotte NC", description: "Urgent passport processing for Charlotte North Carolina travelers with immediate departure needs from CLT." },
    { name: "Expedited Passport Renewal Charlotte NC", description: "Fast passport renewal for Charlotte North Carolina residents with a previously-issued passport." },
    { name: "First-Time Passport Charlotte NC", description: "New passport application services for Charlotte North Carolina residents applying for their first passport." },
    { name: "Child Passport Charlotte NC", description: "Minor passport services for Charlotte North Carolina families with children under 16." },
    { name: "Name Change Passport Charlotte NC", description: "Passport name correction after marriage, divorce, or legal name changes for Charlotte residents." },
    { name: "Second Passport Charlotte NC", description: "Second passport services for Charlotte banking executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Jennifer M.",
      location: "Uptown Charlotte, NC",
      rating: 5,
      text: "My passport expired the week before a banking conference in London. Fast Passport Center had my renewal ready in 4 days. I never had to leave Charlotte. Absolutely incredible service.",
      service: "Passport Renewal",
    },
    {
      name: "David K.",
      location: "Matthews, NC",
      rating: 5,
      text: "Emergency passport for a family emergency in Germany. Got it in 36 hours. The team kept me updated every step. I was amazed this could happen without driving to Atlanta.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah L.",
      location: "Huntersville, NC",
      rating: 5,
      text: "First passport for my 10-year-old before our cruise. Fast Passport Center walked us through every document and had her passport ready in 5 days. Stress-free from start to finish.",
      service: "Child Passport",
    },
    {
      name: "Robert T.",
      location: "Ballantyne, Charlotte",
      rating: 5,
      text: "Lost my passport 4 days before a conference in Tokyo. Fast Passport Center had a replacement in my hands in 30 hours. These guys are lifesavers.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "charlotte-1",
      name: "Charlotte Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Tryon St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 344-4183",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Charlotte, Uptown area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Charlotte facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "charlotte-2",
      name: "Matthews Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11435 E Independence Blvd",
      city: "Matthews",
      state: "NC",
      zip: "28105",
      phone: "(704) 847-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Southeast Charlotte suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Matthews and Mint Hill residents. Less crowded than downtown. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "charlotte-3",
      name: "Huntersville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16835 Caldwell Creek Dr",
      city: "Huntersville",
      state: "NC",
      zip: "28078",
      phone: "(704) 875-3513",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Charlotte, Lake Norman area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Huntersville, Cornelius, and Davidson area. Ample parking. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "charlotte-4",
      name: "Concord Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7850 International Dr",
      city: "Concord",
      state: "NC",
      zip: "28027",
      phone: "(704) 788-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Northeast Charlotte suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Cabarrus County and northeast Charlotte metro. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "charlotte-5",
      name: "Mecklenburg County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "832 E 4th St",
      city: "Charlotte",
      state: "NC",
      zip: "28202",
      phone: "(704) 686-0200",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Mecklenburg County Courthouse, Uptown",
      website: "https://www.mecknc.gov/",
      websiteLabel: "Mecklenburg County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "charlotte-6",
      name: "Gastonia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W Main Ave",
      city: "Gastonia",
      state: "NC",
      zip: "28052",
      phone: "(704) 866-4501",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Charlotte, Gaston County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Gaston County and west Charlotte metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 250 miles (4+ hours) to Atlanta Passport Agency", fpc: "Most Charlotte travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle 500-mile round trip", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "CLT/Finance-Specific Guidance", agency: "Generic — no CLT, AA hub, or banking industry expertise", fpc: "Full CLT/corporate/NASCAR/finance knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming the Atlanta Agency Is Easily Accessible",
      description: "The Atlanta Passport Agency is 250 miles from Charlotte — a 4+ hour drive each way. Many Charlotte residents don't realize this until they need emergency service. Our courier channel eliminates this trip entirely.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Charlotte applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Banking Conference Short-Notice Travel",
      description: "Charlotte's financial sector generates frequent short-notice international travel — quarterly reviews in London, deal closings in Frankfurt, investor meetings in Tokyo. Banking professionals should maintain current passports at all times.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for Minors",
      description: "Carolina families frequently overlook the DS-3053 consent form when one parent is unavailable. This is an automatic rejection — we guide you through it correctly.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Not Accounting for 6-Month Rule",
      description: "Charlotte travelers booking AA flights to Europe or Asia often do not know their passport must have 6 months remaining beyond the return date. We flag this immediately.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your Uptown office, Ballantyne home, or Lake Norman." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Charlotte clients ship from home or office — no need to drive 250 miles to Atlanta." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you skip the 4-hour I-85 drive to the Atlanta Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Charlotte?", a: "We offer Charlotte-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 2–9 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Does Charlotte have its own passport agency?", a: "No — neither Charlotte nor the state of North Carolina has a regional passport agency. The closest facility is the Atlanta Passport Agency, approximately 250 miles away (4+ hours via I-85). Fast Passport Center's courier service means Charlotte residents never need to make that drive." },
    { q: "What is CLT Airport's international reach?", a: "Charlotte Douglas International Airport (CLT) is American Airlines' second-largest hub, offering nonstop flights to London, Frankfurt, Munich, Madrid, Dublin, Rome, and 180+ destinations worldwide. CLT serves as the primary international gateway for the Carolinas and much of the Southeast." },
    { q: "Can you help with urgent banking and finance travel?", a: "Yes. Charlotte is the second-largest banking center in the U.S. — home to Bank of America HQ, Wells Fargo's Eastern HQ, and Truist HQ. We regularly assist finance professionals with short-notice international travel for deal closings, investor meetings, and quarterly reviews in London, Frankfurt, and Tokyo." },
    { q: "Can I get an expedited passport in the Charlotte suburbs?", a: "Absolutely. Fast Passport Center serves all of the Charlotte metro area including Matthews, Mint Hill, Huntersville, Concord, Gastonia, Mooresville, Cornelius, Davidson, and Pineville. We also serve Fort Mill and Rock Hill, SC. Our service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "How much does an expedited passport cost in Charlotte?", a: "Government fees are fixed: $130 for a first-time passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get a passport acceptance in Charlotte?", a: "Charlotte has acceptance facilities at the Main Post Office (Uptown), Matthews Post Office, Huntersville Post Office, Concord Post Office, Gastonia Post Office, and the Mecklenburg County Clerk of Court. We maintain an updated list with hours, photo availability, and appointment options." },
    { q: "Do you serve the South Carolina border communities?", a: "Absolutely. Fast Passport Center serves the entire Charlotte metro area including Fort Mill, Rock Hill, Tega Cay, and Lake Wylie in South Carolina. Our courier service works seamlessly from any address in the Charlotte-Concord-Gastonia metropolitan area." },
    { q: "Can I get a passport photo in Charlotte?", a: "Yes — many Charlotte CVS, Walgreens, UPS Stores, FedEx Office, and Walmart locations offer passport photos. Photos must be 2x2 inches, white background, no glasses, neutral expression. We review your photos before submission." },
    { q: "How fast can I get a passport for a family cruise from Charleston?", a: "Many Charlotte families drive to Charleston (3 hours) for Caribbean cruises. We handle multi-passport family bundles with coordinated timelines so everyone in the family has their passport ready before the cruise departure date." },
    { q: "How do I check my Charlotte passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Charlotte to final return shipping typically matches your chosen speed tier." },
    { q: "What documents do Charlotte applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Charlotte-specific checklist." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Charlotte Residents",
    intro: "Charlotte's unique position as America's second-largest banking center — anchored by CLT as an American Airlines global hub and the closest passport agency 250 miles away — creates distinct passport timing challenges. Here's what Charlotte travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "CLT — Charlotte Douglas International Airport",
        subtitle: "American Airlines' second-largest hub, 180+ nonstop destinations",
        description: "CLT handles more than 50 million passengers annually and is AA's critical Southeast hub. Nonstop flights to London, Frankfurt, Munich, Madrid, Dublin, Rome, and 180+ destinations worldwide. The airport's European network has expanded dramatically in recent years, with new routes to Paris, Barcelona, and seasonal service to additional European cities. The AA hub means Charlotte has direct international access that far exceeds what a city its size would typically have — and that creates constant passport demand.",
        tip: "AA's CLT-Europe routes are popular with banking professionals heading to London and Frankfurt. These flights often depart early evening — if you discover a passport issue the morning of travel, our courier service may still be able to help with same-day agency submission.",
      },
      {
        icon: "ri-bank-line",
        title: "Banking & Finance Global Travel",
        subtitle: "Bank of America, Wells Fargo, Truist — America's #2 banking center",
        description: "Charlotte is the second-largest banking center in the United States after New York City. Bank of America's global headquarters, Wells Fargo's Eastern operations, and Truist's corporate center create a constant stream of international travel. Quarterly earnings reviews in London, M&A deal closings in Frankfurt, investor roadshows in Tokyo — Charlotte's financial professionals travel globally on timelines that standard passport processing cannot accommodate.",
        tip: "Banking travel is notoriously short-notice: a deal accelerates, a client meeting gets moved up, or a quarterly review gets scheduled with 1–2 weeks of lead time. Finance professionals should maintain a current passport at all times — and consider a second passport if visa processing delays could impact travel.",
      },
      {
        icon: "ri-trophy-line",
        title: "NASCAR & Motorsports International Travel",
        subtitle: "90% of NASCAR teams based within 50 miles of Charlotte",
        description: "The Charlotte region is the global epicenter of NASCAR, with the NASCAR Hall of Fame in Uptown and virtually every major team — Hendrick Motorsports, Joe Gibbs Racing, Team Penske, Stewart-Haas — headquartered within an hour's drive. While NASCAR is American, the motorsports industry is global: team members travel to Formula 1 races in Monaco, Silverstone, and Suzuka; engineers attend technical conferences in Germany and Italy; and drivers compete in international exhibition events year-round.",
        tip: "Motorsports travel often follows the global racing calendar, with predictable spikes around the Monaco Grand Prix (May), 24 Hours of Le Mans (June), and Goodwood Festival of Speed (July). Teams should process passports during the NASCAR off-season (November–January) to avoid conflicts with the racing schedule.",
      },
      {
        icon: "ri-road-map-line",
        title: "The 250-Mile Atlanta Agency Reality",
        subtitle: "North Carolina has no passport agency — Atlanta is 4+ hours away",
        description: "North Carolina is one of the largest states without a regional passport agency. For Charlotte residents, the nearest emergency option is the Atlanta Passport Agency — 250 miles south via I-85, a 4+ hour drive each way. For a working professional or a family with kids, this effectively means losing an entire day (or overnight stay) just to submit a passport application. This geographic reality makes our courier service especially valuable for Charlotte travelers.",
        tip: "The Atlanta drive also means you need to factor in I-85 traffic through Greenville-Spartanburg and Atlanta metro congestion. What maps show as 4 hours can easily become 5–6 hours during peak travel times. Our courier service eliminates this variable entirely.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Charlotte & the Carolinas Travel Corridor",
      description: "CLT serves as the international gateway not just for Charlotte but for the entire Carolinas — including the Research Triangle, the Triad, Asheville, Columbia, and Greenville-Spartanburg. Many travelers from across both states funnel through CLT for international departures, and we regularly help families, professionals, and students from across the Carolinas coordinate passport timelines around CLT flight schedules.",
    },
  },
  destinations: {
    title: "Where Charlotte Travelers Go — And Why Passports Get Urgent",
    intro: "CLT's AA hub reach and Charlotte's finance/NASCAR prominence mean Queen City travelers need passports for destinations spanning the globe. Here are the most common international destinations and the urgency patterns we see.",
    stats: [
      { stat: "40%", label: "of Charlotte expedited requests are banking/finance-related with 1–3 weeks notice" },
      { stat: "2–3 Weeks", label: "average lead time Charlotte finance professionals have from deal confirmation to international travel" },
      { stat: "May–Jul", label: "peak season when European banking travel, summer vacations, and racing calendar collide" },
      { stat: "250 Miles", label: "distance to nearest passport agency in Atlanta — 4+ hour drive each way via I-85" },
    ],
    destinations: [
      { name: "United Kingdom & Ireland", context: "CLT-London and CLT-Dublin nonstops, banking headquarters, finance conferences, AA partner British Airways", urgency: "Quarterly reviews and deal closings booked 1–3 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "CLT-Frankfurt and CLT-Munich nonstops, banking and automotive, Deutsche Bank and BMW connections", urgency: "M&A and banking meetings have fixed dates with 2–3 weeks notice", icon: "ri-map-pin-2-line" },
      { name: "Spain & Italy", context: "CLT-Madrid, CLT-Barcelona, CLT-Rome nonstops, finance, leisure, heritage travel", urgency: "Summer peak May–September; banking travel booked 2–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "CLT extensive Caribbean and Mexico network, AA hub with Cancun, Punta Cana, Montego Bay, Nassau nonstops", urgency: "Resort and cruise bookings spike January through March for spring/summer", icon: "ri-map-pin-2-line" },
      { name: "Japan & Asia", context: "CLT-Asia connections via AA hubs, banking and motorsports travel, supplier meetings", urgency: "Finance and motorsports trips booked 2–4 weeks out with visa requirements", icon: "ri-map-pin-2-line" },
      { name: "France", context: "CLT-Paris nonstop, banking and leisure, AA hub connections throughout Europe", urgency: "Fashion week, banking conferences, and summer tourism create May–September demand", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Carolina Service Areas",
    crossLinksDesc: "We serve travelers across the Tar Heel State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Raleigh", route: "/cities/raleigh" },
      { name: "Greensboro", route: "/cities/greensboro" },
      { name: "Winston-Salem", route: "/cities/winston-salem" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Uptown Charlotte", address: "201 S College St, Charlotte, NC 28202", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — South Park", address: "4300 Park Rd, Charlotte, NC 28209", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Walmart Supercenter — Matthews", address: "10310 E Independence Blvd, Matthews, NC 28105", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "FedEx Office — Charlotte", address: "550 S Tryon St, Charlotte, NC 28202", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://local.fedex.com/en-us/nc/charlotte" },
    { name: "CVS Pharmacy — Huntersville", address: "16429 Statesville Rd, Huntersville, NC 28078", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Concord", address: "8525 Pit Stop Ct NW, Concord, NC 28027", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Gastonia", address: "3690 E Franklin Blvd, Gastonia, NC 28056", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walmart — Fort Mill, SC", address: "1220 Highway 160 E, Fort Mill, SC 29708", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Charlotte South",
      address: "8520 E Independence Blvd, Charlotte, NC 28227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Charlotte North",
      address: "5311 Idlewild Rd N, Charlotte, NC 28227",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Huntersville",
      address: "16225 Statesville Rd, Huntersville, NC 28078",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Lake Norman area residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Gastonia",
      address: "245 E Garrison Blvd, Gastonia, NC 28054",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Gaston County and west Charlotte metro. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "7 miles west of downtown Charlotte",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "American Airlines' second-largest hub. Nonstop flights to London, Frankfurt, Munich, Madrid, Dublin, Rome, Paris, and 180+ destinations worldwide. Primary international gateway for the Carolinas.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: true,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from North Carolina Vital Records (NCDHHS). Online, mail, or in-person at the Raleigh office. Serving all NC counties including Mecklenburg.",
      url: "https://vitalrecords.nc.gov/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through North Carolina Vital Records. Required for estate, legal, and survivor benefit matters.",
      url: "https://vitalrecords.nc.gov/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage records from the Mecklenburg County Register of Deeds. Required for name change passport applications for Mecklenburg County marriages.",
      url: "https://meckrod.com/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Mecklenburg County Clerk of Superior Court. Required for name change passport corrections and legal documentation.",
      url: "https://www.nccourts.gov/locations/mecklenburg-county/mecklenburg-county-clerk-of-superior-court",
    },
  ],
};